(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dicomParser", [], factory);
	else if(typeof exports === 'object')
		exports["dicomParser"] = factory();
	else
		root["dicomParser"] = factory();
})(self, function() {
return 